function safeStringify(obj) {
    const seen = new WeakSet();
    return JSON.stringify(obj, (key, value) => {
        if (typeof value === "object" && value !== null) {
            if (seen.has(value) || value instanceof Event) {
                return undefined; // Ignore circular reference
            }
            seen.add(value);
        }
        return value;
    },1);
}

export default function O({style,children}){
  return (
    <div class="rel" 
      style={{
      border:'3px solid red',
        minHeight:0,
        overflow:'scroll',
        maxHeight:'100vh',
    }}>
      <pre style={{
        height:'100%',
        minHeight:0,
        border:'3px solid lime',
        overflowY:'scroll',
        fontSize:8,
        userSelect:'text',
        background:'white',

        ...style,
      }}>
        {safeStringify(children,null,1)}
      </pre>
    </div>
  )
}
